export default __webpack_public_path__ + "static/media/Sorting_08.a86c166f.png";